import type { Logger } from "@expert/logging";

import type { ChallengeInfo } from "../api/getChallengesForEmployee";

export function getChallengeDescription(logger: Logger, challenge: ChallengeInfo): string {
    const { challengeType, details } = challenge;

    const target = details[0].conditions.find((c) => c.threshold === "TARGET");
    const limit = details[0].conditions.find((c) => c.threshold === "UPPER_LIMIT");

    if (target == null || limit == null) return getChallengeName(logger, challenge);

    switch (challengeType) {
        case "solo":
            return `Get ${target.targetValue} enrolls with a max of ${limit.targetValue} cancels.`;
        case "team":
            return `The first team to ${target.targetValue} enrolls with a max of ${limit.targetValue} cancels wins.`;
        default:
            return getChallengeName(logger, challenge);
    }
}

function getChallengeName(logger: Logger, challenge: ChallengeInfo): string {
    const childLogger = logger.child({ module: "getChallengeDescription", supportTeam: "sales" });
    childLogger.warn({ challenge }, "Unknown challengeType");
    return challenge.challengeName;
}
